import axios from '../../axios'

/*
 * 文章数据接口
 */

// 首页链接配置
export const carouselApi = (data) => {
    return axios({
        url: '/api/base/carousel',
        method: data.method || 'GET',
        data: data.data
    })
}

export const baseMunu = (data) => {
    return axios({
        url: '/api/base/menu',
        method: data.method || 'GET',
        data: data.data
    })
}


export const operateDialog = (data) => {
    return axios({
        url: '/api/base/index/pop/tip',
        method: data.method || 'GET',
        data: data.data
    })
}

export const getDialogInfo = (data) => {
    return axios({
        url: '/api/base/index/pop/tip/info',
        method:'GET',
        data: data.data
    })
}

export const baseCustomer = (data) => {
    return axios({
        url: '/api/base/cs/config',
        method: data.method || 'GET',
        data: data.data
    })
}

export const getCustomerInfo = (data) => {
    return axios({
        url: '/api/base/cs/config/info',
        method: 'GET',
        data: data.data
    })
}




// WEBPACK FOOTER //
// ./src/http/moudules/customize/carousel.js